import type { PageStateWithValue, UpdatePageStateAction } from '@lighthouse/core'
import type { ActionFlowNode, FlowNodeResultADT } from '@lighthouse/shared'
import { asyncGenerateVariableValue, getInitInnerTypeADTValue, isEmptyRichTextValue, transformValueByInnerType } from '@lighthouse/shared'
import { find } from 'rambda'

import type { ExecuteActionParams } from '../type'

export const updatePageState = async (
    config: UpdatePageStateAction['data']['updatePageState'] | undefined,
    params: ExecuteActionParams
) => {
    const { actionEvents, pageStateParameterValues } = params
    if (!config) {
        return
    }
    const { pageStateId, value } = config
    const pageStateParameterValue = find(item => item.id === pageStateId, pageStateParameterValues || [])
    if (!pageStateId || !pageStateParameterValue) {
        return
    }
    const val =
        value && !isEmptyRichTextValue(value)
            ? await asyncGenerateVariableValue({ innerType: pageStateParameterValue.innerType, jsonContent: value, extraParams: params })
            : getInitInnerTypeADTValue(pageStateParameterValue.innerType).value
    actionEvents.updatePageState({
        id: pageStateId,
        innerType: pageStateParameterValue.innerType,
        value: transformValueByInnerType({ innerType: pageStateParameterValue.innerType, value: val })
    } as PageStateWithValue)

    return true
}

export const handleUpdatePageStateList = async (
    config: UpdatePageStateAction['data']['updatePageState'] | undefined,
    params: ExecuteActionParams
): Promise<FlowNodeResultADT> => {
    await updatePageState(config, params)
    return {
        type: 'record',
        success: true
    }
}

export const handleUpdatePageStateStream = async (
    node: ActionFlowNode<{ config: UpdatePageStateAction['data']['updatePageState'] }>,
    params: ExecuteActionParams
): Promise<FlowNodeResultADT> => {
    await updatePageState(node.data.config, params)
    return {
        type: 'record',
        success: true
    }
}
